/**
 * Array.prototype.at() polyfill for iOS 16.1 and older browsers
 * 解决 marked.js 在 iOS 16.1 上使用 Array.at() 导致的兼容性问题
 *
 * Reference: https://github.com/tc39/proposal-relative-indexing-method
 */
if (!Array.prototype.at) {
  Array.prototype.at = function (index) {
    // 将负索引转换为正索引
    const len = this.length
    const relativeIndex = index >= 0 ? index : len + index

    // 检查索引是否在有效范围内
    if (relativeIndex < 0 || relativeIndex >= len) {
      return undefined
    }

    return this[relativeIndex]
  }
}
